import { GetterTree } from "vuex";
import PropertyStoreTypes from "./define-types.store";
import {
	LargeMailingModel,
	LargeMailingLookupInfosDto
} from "../../../models/report";
import { ILargeMailingState } from "./states.store";
const largeMailingGetters: GetterTree<ILargeMailingState, {}> = <GetterTree<
	ILargeMailingState, {}>>{
		service: (state: ILargeMailingState) => state.service,

		/** GET ALL CURRENT SEND EMAIL MODEL */
		[PropertyStoreTypes.Get.GET_LARGEMAILING]: (state: ILargeMailingState) => {
			let model = state.largeMailing || new LargeMailingModel();
			if (model.LookupInfos == null)
				model.LookupInfos = new LargeMailingLookupInfosDto();
			return model;
  },
    
		/** GET DEMAND INFO */
		[PropertyStoreTypes.Get.DEMAND_INFOS]: (state: ILargeMailingState) => {
			return state.demandInfos;
		},
		/** GET PERSON INFO */
		[PropertyStoreTypes.Get.PERSON_INFOS]: (state: ILargeMailingState) => {
			return state.personInfos;
		},
	};

export default largeMailingGetters;
